import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PUBLIC_ORIGIN = /(^|\.)clip-ex\.com$/.test(window.location.hostname) ? "https://www.clip-ex.ca" : window.location.origin;
const TOKEN_KEY = "clipx_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  cfg.headers["X-Lang"] = document.documentElement.lang || "fr";
  return cfg;
});

export const mediaUrl = (path, extra = "") => `${API}${path}?token=${getToken()}${extra}`;

let genericError = "Une erreur est survenue.";
export const setGenericError = (m) => { if (m) genericError = m; };

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return genericError;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const fmtTime = (t = 0) => {
  const m = Math.floor(t / 60);
  const s = Math.floor(t % 60);
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

export const fmtTimePrecise = (t = 0) => `${fmtTime(t)}.${Math.floor((t % 1) * 10)}`;

export const PLATFORMS = [
  { id: "tiktok", label: "TikTok", aspect: "9:16", upload: "https://www.tiktok.com/upload" },
  { id: "youtube_shorts", label: "YT Shorts", aspect: "9:16", upload: "https://studio.youtube.com" },
  { id: "instagram_reels", label: "IG Reels", aspect: "9:16", upload: "https://www.instagram.com" },
  { id: "youtube", label: "YouTube", aspect: "16:9", upload: "https://studio.youtube.com" },
  { id: "x", label: "X / Twitter", aspect: "16:9", upload: "https://x.com/compose/post" },
  { id: "twitch", label: "Twitch", aspect: "16:9", upload: "https://dashboard.twitch.tv" },
  { id: "facebook", label: "Facebook", aspect: "9:16", upload: "https://www.facebook.com/reels/create" },
  { id: "kick", label: "Kick", aspect: "16:9", upload: "https://kick.com/dashboard" },
  { id: "snapchat", label: "Snapchat", aspect: "9:16", upload: "https://my.snapchat.com" },
  { id: "discord", label: "Discord", aspect: "16:9", upload: "https://discord.com/app" },
  { id: "rumble", label: "Rumble", aspect: "16:9", upload: "https://rumble.com/upload.php" },
  { id: "trovo", label: "Trovo", aspect: "16:9", upload: "https://trovo.live" },
];

export const platformLabel = (id) => PLATFORMS.find((p) => p.id === id)?.label || id;

export const ASPECTS = [
  { id: "9:16", label: "9:16", hint: "TikTok · Shorts · Reels", ratio: 9 / 16 },
  { id: "16:9", label: "16:9", hint: "YouTube · X", ratio: 16 / 9 },
  { id: "1:1", label: "1:1", hint: "Feed carré", ratio: 1 },
  { id: "4:5", label: "4:5", hint: "Feed Instagram", ratio: 4 / 5 },
];

export const CATEGORY_COLORS = {
  kill: "#ff4d6d",
  clutch: "#3ad7ff",
  funny: "#ffc94d",
  fail: "#ff8a3d",
  epic: "#a746ff",
  reaction: "#2f7bff",
  skill: "#22e3a1",
  rage: "#ff3df0",
};
